// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"68":"b72ea5f6","164":"67b63ccd","613":"6b872ebc","806":"d3f2963d"}[chunkId] + ".css";
};